import { useEffect } from 'react';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

// Lib
// Stores
import { useDatepickerGlobalStore } from '@/utils/zustand/providers/datepicker-global-provider';

import { CUSTOM } from '@/lib/periods';

const ApplyGlobalStoreDates = ({ setRequestParams }) => {
    const { date, period } = useDatepickerGlobalStore((state) => state);

    useEffect(() => {
        if (period === CUSTOM) {
            setRequestParams((prevState) => ({
                ...prevState,
                period: CUSTOM,
                start: dayjs(date.from).format('YYYY-MM-DD'),
                end: dayjs(date.to).format('YYYY-MM-DD')
            }));
            return;
        }
        setRequestParams((prevState) => {
            const stateToUpdate = { ...prevState };
            if (stateToUpdate) {
                delete stateToUpdate.start;
                delete stateToUpdate.end;
            }
            return {
                ...stateToUpdate,
                period: period
            };
        });
    }, [date, period]);
};

export default ApplyGlobalStoreDates;
